export { TheCerebralWay } from "./TheCerebralWay"
export { FAQSection } from "../../../shared/FAQSection"
export { Testimonials } from "../../../shared/Testimonials"
export { HeroSection } from "../../../shared/HeroSection"
export { ChooseService } from "../../../shared/ChooseService"
export { AlternatingSplashes } from "../../../shared/AlternatingSplashes"
export { GettingStarted } from "../../../shared/GettingStarted"
